import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { AntAim, FiRefreshCw } from '@fmbt/ui/icons';
import DefaultButton from 'components/atoms/DefaultButton';
import ActionType from 'store/modules/backOfficeDeviceMapPoints/constants';
import { makeSelectIsLoading } from 'store/modules/loading/selectors';

import './styles.less';

interface BackOfficeDeviceMapLegendProps {
  onRecenter: () => void;
  onRefresh: () => void;
}

const actions = [ActionType.LOAD_BACK_OFFICE_DEVICE_MAP_POINTS_REQUEST];
const selectIsLoading = makeSelectIsLoading(actions);

function BackOfficeDeviceMapLegend({
  onRecenter,
  onRefresh
}: BackOfficeDeviceMapLegendProps): JSX.Element {
  const isLoading = useSelector(selectIsLoading);

  function ControlButtons() {
    return (
      <div className="BackOfficeDeviceMapLegend-action">
        <DefaultButton
          type="primary"
          icon={<AntAim />}
          onClick={onRecenter}
        />
        <DefaultButton
          type="lets-go"
          icon={<FiRefreshCw size={16} />}
          loading={isLoading}
          onClick={onRefresh}
        />
      </div>
    );
  }

  return (
    <div className="BackOfficeDeviceMapLegend">
      <h4>Controls</h4>
      <ControlButtons />
    </div>
  );
}

export default memo(BackOfficeDeviceMapLegend);
